module.exports = __webpack_public_path__ + "static/media/Angle's Class II Division II3.390b060d.png";